import RecommendedRequests from '../../server/recommended';
import { addLoading, removeLoading } from './loading';

export const setRecommendeds = recommendeds => ({
  type: 'PANEL_RECOMMENDEDS_GET',
  recommendeds,
});

const createRecommended = recommended => async (dispatch) => {
  dispatch(addLoading());
  try {
    await RecommendedRequests.createRecommended(recommended);
  } finally {
    dispatch(removeLoading());
  }
};

const updateRecommended = recommended => async (dispatch) => {
  dispatch(addLoading());
  try {    
    await RecommendedRequests.updateRecommended(recommended);
  } finally {
    dispatch(removeLoading());
  }
};

const getRecommendeds = (limit, skip, search = '', order = '', field = '') => async (dispatch) => {
  if (!search) dispatch(addLoading());
  try {
    const recommended = await RecommendedRequests.getRecommendeds(limit, skip, search, order, field);
    dispatch(setRecommendeds(recommended));
  } finally {
    if (!search) dispatch(removeLoading());
  }
};

const removeRecommended = id => async (dispatch) => {
  dispatch(addLoading());
  try {
    await RecommendedRequests.removeRecommended(id);
  } finally {
    dispatch(removeLoading());
  }
};

export const getCsvRecommendedModel = () => async (dispatch) => {
  dispatch(addLoading());
  try {
    await RecommendedRequests.getCsvRecommendedModel();
  } finally {
    dispatch(removeLoading());
  }
};

const getCsvRecommendedsReport = () => async (dispatch) => {
  dispatch(addLoading());
  try {
    await RecommendedRequests.getCsvRecommendedsReport();
  } finally {
    dispatch(removeLoading());
  }
};

export const uploadRecommendeds = file => async (dispatch) => {
  dispatch(addLoading());
  try {
    const result = await RecommendedRequests.uploadCsvRecommendeds(file);
    return result;
  } finally {
    dispatch(removeLoading());
  }
};

export default {
  createRecommended,
  getRecommendeds,
  removeRecommended,
  updateRecommended,
  getCsvRecommendedModel,
  getCsvRecommendedsReport,
  uploadRecommendeds,
};
